module.exports = __webpack_public_path__ + "media/images/icon_list/edit-9c1fff42781cbbbd926ac90fb53faad9.svg";